import { render } from "./ExplicitBinding.vue?vue&type=template&id=354934a6&scoped=true"
import script from "./ExplicitBinding.vue?vue&type=script&lang=js"
export * from "./ExplicitBinding.vue?vue&type=script&lang=js"

import "./ExplicitBinding.vue?vue&type=style&index=0&id=354934a6&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354934a6"]])

export default __exports__